import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import login from '../../images/login/login.png';

const Contact = () => {
    useEffect( () => {
        Aos.init({duration: 2000})
    } , [])
    return (
        <div className='lg:mt-5'>
            <div className='flex justify-center items-center'>
                <h2 data-aos='flip-right' className='text-xl mb-5 mt-16 lg:text-4xl font-semibold text-center md:mb-5 border border-blue-600 inline-block rounded rounded-tl-full rounded-br-full px-10 py-2'>Contact Me</h2>
            </div>
            
            <div  className="hero  lg:w-10/12 mx-auto">
                <div className="hero-content flex-col grid lg:grid-cols-2 lg:flex-row-reverse">
                    <div data-aos='flip-left' className="text-center lg:text-left">
                        <img src={login} alt="" />
                        
                    </div>
                    <div data-aos='flip-right' className="card flex-shrink-0 w-full text-center bg-base-100">
                    <h1 className="text-4xl font-bold">Send Your Message</h1>
                        <div className="card-body">
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Email</span>
                                </label>
                                <input type="text" placeholder="email" className="input input-bordered" />
                            </div>
                            {/* <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Password</span>
                                </label>
                                <input type="text" placeholder="password" className="input input-bordered" />
                                <label className="label">
                                    <Link href="#" className="label-text-alt link link-hover">Forgot password?</Link>
                                </label>
                            </div> */}
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Your Message</span>
                                </label>
                                <input type="text" placeholder="Write Your Message" className="input input-bordered h-14" />
                            </div>
                            <div className="form-control mt-6">
                                <button className="btn btn-primary">Send</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;